import React, { useEffect } from "react";
import { Box } from "@mui/material";
// import Navbar from "../../PrivacyPolicy/Navbar";
import FooterSection from "../../Footer/FooterSection";
// import backgroundImage from "../../../images/backgroundimg.png";
import WelcomeSection from "./Welcome";
import OurMission from "./Ourmission";
import Getstarted from "./Getstarted";
import { Whychooseus } from "./Whychooseus";
import Howtouseapp from "./Howtouseapp";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);
  return (
    <>
      <Box>
        {/* <Navbar
          pageName={{
            navbarName: "ABOUT US",
            backimg: backgroundImage,
          }}
        /> */}
      </Box>

       <WelcomeSection />
       <OurMission />
      <Whychooseus />
      <Getstarted />
      <Howtouseapp />   
      <FooterSection />
    </>
  );
};
export default AboutUs;
